import { Holiday } from '../holidays';

export const CANADA_HOLIDAYS: Record<number, Holiday[]> = {
    2024: [
        { name: "New Year's", date: new Date(2024, 0, 1) },
        { name: "Family Day", date: new Date(2024, 1, 19) },
        { name: "Good Friday", date: new Date(2024, 2, 29) },
        { name: "Victoria Day", date: new Date(2024, 4, 20) },
        { name: "Canada Day", date: new Date(2024, 6, 1) },
        { name: "Civic Holiday", date: new Date(2024, 7, 5) },
        { name: "Labour Day", date: new Date(2024, 8, 2) },
        { name: "Thanksgiving", date: new Date(2024, 9, 14) },
        { name: "Christmas", date: new Date(2024, 11, 25) },
        { name: "Boxing Day", date: new Date(2024, 11, 26) }
    ],
    2025: [
        { name: "New Year's", date: new Date(2025, 0, 1) },
        { name: "Family Day", date: new Date(2025, 1, 17) },
        { name: "Good Friday", date: new Date(2025, 3, 18) },
        { name: "Victoria Day", date: new Date(2025, 4, 19) },
        { name: "Canada Day", date: new Date(2025, 6, 1) },
        { name: "Civic Holiday", date: new Date(2025, 7, 4) },
        { name: "Labour Day", date: new Date(2025, 8, 1) },
        { name: "Thanksgiving", date: new Date(2025, 9, 13) },
        { name: "Christmas", date: new Date(2025, 11, 25) },
        { name: "Boxing Day", date: new Date(2025, 11, 26) }
    ],
    2026: [
        { name: "New Year's", date: new Date(2026, 0, 1) },
        { name: "Family Day", date: new Date(2026, 1, 16) },
        { name: "Good Friday", date: new Date(2026, 3, 3) },
        { name: "Victoria Day", date: new Date(2026, 4, 18) },
        { name: "Canada Day", date: new Date(2026, 6, 1) },
        { name: "Civic Holiday", date: new Date(2026, 7, 3) },
        { name: "Labour Day", date: new Date(2026, 8, 7) },
        { name: "Thanksgiving", date: new Date(2026, 9, 12) },
        { name: "Christmas", date: new Date(2026, 11, 25) },
        { name: "Boxing Day", date: new Date(2026, 11, 28) }
    ]
};
